export const ProfileBilling = {
  bindings: {
    isLoading: '<',
    subscription: '<',
    subscriptions: '<',
    onClickCancel: '&',
    onClickDowngrade: '&',
    onClickResume: '&',
  },

  template: `
    <div class="row profile-billing">
      <div class="col-md-4">
        <h5>Billing History</h5>
        <p>A record of any Coaching Zone purchases you've made.</p>
      </div>
      <div class="col-md-8" ng-if="$ctrl.subscriptions">
        <form-group-row>
          <form-group-left>
            Your Products
          </form-group-left>
          <form-group-right>
            <select class="form-control"
              ng-model="$ctrl.subscription"
              ng-value="$ctrl.subscription.id"
              ng-options="item as item.title for item in $ctrl.subscriptions track by item.id">
              <option value="">-- Select Product --</option>
            </select>
          </form-group-right>
        </form-group-row>
        <div class="pt-2">
          <form-group-row ng-if="$ctrl.subscription.isWeekly">
            <form-group-right>
              <p ng-show="$ctrl.subscription.status === 'active'">
                Next Billing Date -
                <strong>{{ $ctrl.subscription.nextBillingDate | date: 'dd/MM/yyyy' }}</strong>
              </p>
              <p ng-show="$ctrl.subscription.status === 'delayed_cancelled'">
                You have cancelled your subcription to {{ $ctrl.subscription.title }}
                and will no longer be able to access {{ $ctrl.subscription.title }}
                after {{ $ctrl.subscription.nextBillingDate | date:'dd/MM/yyyy' }}.
                You can still login and reactivate your subscription at any time.
                <span class="d-block pt-3">
                  <button-link ng-click="$ctrl.onClickResume({ subscriptionId: $ctrl.subscription.id })">
                    <spinner is-loading="$ctrl.isLoading">
                      Resume Subscription
                    <spinner>
                  </button-link>
                </span>
              </p>
              <p ng-show="$ctrl.subscription.status === 'past_due'" class="text-danger">
                <a ui-sref="profileCreditCard({ action: 'update' })">
                  Update Credit Card
                </a><br />
                We've had a problem processing your payment. Please click the link above to update your credit card details or contact
                <a href="mailto:support@voome.com.au">support@voome.com.au</a>
              </p>
              <p ng-show="$ctrl.subscription.status === 'active' && $ctrl.subscription.chargifySubscriptionId">
                <a ui-sref="profileCreditCard({ action: 'update' })">
                  Update Credit Card
                </a>
                <span ng-show="$ctrl.subscription.voomeProductType === 'bundle'">
                  <br>
                  <button-link ng-click="$ctrl.onClickDowngrade({ subscription: $ctrl.subscription })">
                    Modify Subscription
                  </button-link>
                </span>
                <br>
                <button-link ng-click="$ctrl.onClickCancel({ subscription: $ctrl.subscription })">
                  Cancel Subscription
                </button-link>
              </p>
            </form-group-right>
          </form-group-row>
          <h6 class="ml-md-2 mb-3 text-dark">Invoices</h6>
          <div class="d-none d-md-block">
            <table class="table">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Status</th>
                <th>Amount</th>
              </tr>
              <tr
                ng-show="$ctrl.subscription.invoices.length > 0"
                ng-repeat="invoice in $ctrl.subscription.invoices track by $index">
                <td>{{ invoice.createdAt | date:'dd/MM/yyyy' }}</td>
                <td>{{ invoice.memo }}</td>
                <td>{{ invoice.paymentStatus }}</td>
                <td>{{ invoice.amountInCents / 100 | currency }}</td>
              </tr>
              <tr ng-hide="$ctrl.subscription.invoices.length > 0">
                <td colspan="4">No Invoices available.</td>
              </tr>
            </table>
          </div>
          <div class="d-md-none">
            <table class="table">
              <tr
                ng-show="$ctrl.subscription.invoices.length > 0"
                ng-repeat="invoice in $ctrl.subscription.invoices track by $index">
                <td class="pl-0">
                  <strong>Date:</strong> {{ invoice.createdAt | date:'dd/MM/yyyy' }}<br>
                  <strong>Description:</strong> {{ invoice.memo }}<br>
                  <strong>Status:</strong> {{ invoice.paymentStatus }}<br>
                  <strong>Amount:</strong> {{ invoice.amountInCents / 100 | currency }}
                </td>
              </tr>
              <tr ng-hide="$ctrl.subscription.invoices.length > 0">
                <td colspan="4">No Invoices available.</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileBilling.js